var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDictation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 298.49 202.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-154,.cls-155,.cls-2{mix-blend-mode:multiply;}.cls-2{opacity:0.3;}.cls-3{opacity:0;fill:url(#linear-gradient);}.cls-4{opacity:0.09;fill:url(#linear-gradient-2);}.cls-5{opacity:0.18;fill:url(#linear-gradient-3);}.cls-6{opacity:0.27;fill:url(#linear-gradient-4);}.cls-7{opacity:0.36;fill:url(#linear-gradient-5);}.cls-8{opacity:0.45;fill:url(#linear-gradient-6);}.cls-9{opacity:0.55;fill:url(#linear-gradient-7);}.cls-10{opacity:0.64;fill:url(#linear-gradient-8);}.cls-11{opacity:0.73;fill:url(#linear-gradient-9);}.cls-12{opacity:0.82;fill:url(#linear-gradient-10);}.cls-13{opacity:0.91;fill:url(#linear-gradient-11);}.cls-14{fill:url(#linear-gradient-12);}.cls-15{opacity:0.8;fill:url(#New_Gradient_Swatch_copy_26);}.cls-16{mix-blend-mode:screen;}.cls-17{mix-blend-mode:color-dodge;opacity:0.6;}.cls-18{fill:url(#linear-gradient-13);}.cls-19{fill:url(#linear-gradient-14);}.cls-20{fill:url(#New_Gradient_Swatch_copy_9);}.cls-21{fill:url(#linear-gradient-15);}.cls-22{fill:url(#linear-gradient-16);}.cls-23{fill:url(#linear-gradient-17);}.cls-24{fill:url(#New_Gradient_Swatch_copy_9-2);}.cls-25{fill:url(#linear-gradient-18);}.cls-26{fill:url(#linear-gradient-19);}.cls-27{fill:url(#linear-gradient-20);}.cls-28{fill:url(#New_Gradient_Swatch_copy_8);}.cls-29{fill:url(#New_Gradient_Swatch_copy_9-3);}.cls-30{fill:url(#linear-gradient-21);}.cls-31{fill:url(#New_Gradient_Swatch_copy_9-4);}.cls-32{fill:url(#linear-gradient-22);}.cls-33{fill:url(#linear-gradient-23);}.cls-34{fill:url(#New_Gradient_Swatch_copy_8-2);}.cls-35{fill:url(#linear-gradient-24);}.cls-36{fill:url(#linear-gradient-25);}.cls-37{fill:url(#New_Gradient_Swatch_copy_9-5);}.cls-38{fill:url(#linear-gradient-26);}.cls-39{fill:url(#linear-gradient-27);}.cls-40{fill:url(#linear-gradient-28);}.cls-41{fill:url(#New_Gradient_Swatch_copy_9-6);}.cls-42{fill:url(#linear-gradient-29);}.cls-43{fill:url(#New_Gradient_Swatch_copy_8-3);}.cls-44{fill:url(#linear-gradient-30);}.cls-45{fill:url(#linear-gradient-31);}.cls-46{fill:url(#New_Gradient_Swatch_copy_8-4);}.cls-47{fill:url(#linear-gradient-32);}.cls-48{fill:url(#linear-gradient-33);}.cls-49{fill:url(#linear-gradient-34);}.cls-50{fill:url(#New_Gradient_Swatch_copy_9-7);}.cls-51{fill:url(#linear-gradient-35);}.cls-52{fill:url(#linear-gradient-36);}.cls-53{fill:url(#linear-gradient-37);}.cls-54{fill:url(#New_Gradient_Swatch_copy_8-5);}.cls-55{fill:url(#linear-gradient-38);}.cls-56{fill:url(#linear-gradient-39);}.cls-57{fill:url(#linear-gradient-40);}.cls-58{fill:url(#linear-gradient-41);}.cls-59{fill:url(#linear-gradient-42);}.cls-60{fill:url(#New_Gradient_Swatch_copy_8-6);}.cls-61{fill:url(#linear-gradient-43);}.cls-62{fill:url(#linear-gradient-44);}.cls-63{fill:url(#linear-gradient-45);}.cls-64{fill:url(#New_Gradient_Swatch_copy_9-8);}.cls-65{fill:url(#New_Gradient_Swatch_copy_9-9);}.cls-66{fill:url(#New_Gradient_Swatch_copy_9-10);}.cls-67{fill:url(#linear-gradient-46);}.cls-68{fill:url(#New_Gradient_Swatch_copy_9-11);}.cls-69{fill:url(#linear-gradient-47);}.cls-70{fill:url(#linear-gradient-48);}.cls-71{fill:url(#linear-gradient-49);}.cls-72{fill:url(#New_Gradient_Swatch_copy_9-12);}.cls-73{fill:url(#linear-gradient-50);}.cls-74{fill:url(#New_Gradient_Swatch_copy_9-13);}.cls-75{fill:url(#linear-gradient-51);}.cls-76{fill:url(#linear-gradient-52);}.cls-77{fill:url(#New_Gradient_Swatch_copy_9-14);}.cls-78{fill:url(#linear-gradient-53);}.cls-79{fill:url(#linear-gradient-54);}.cls-80{fill:url(#linear-gradient-55);}.cls-81{fill:url(#linear-gradient-56);}.cls-82{fill:url(#New_Gradient_Swatch_copy_9-15);}.cls-83{fill:url(#linear-gradient-57);}.cls-84{fill:url(#linear-gradient-58);}.cls-85{fill:url(#linear-gradient-59);}.cls-86{fill:url(#New_Gradient_Swatch_copy_8-7);}.cls-87{fill:url(#linear-gradient-60);}.cls-88{fill:url(#New_Gradient_Swatch_copy_9-16);}.cls-89{fill:url(#New_Gradient_Swatch_copy_8-8);}.cls-90{fill:url(#New_Gradient_Swatch_copy_9-17);}.cls-91{fill:url(#linear-gradient-61);}.cls-92{fill:url(#linear-gradient-62);}.cls-93{fill:url(#New_Gradient_Swatch_copy_9-18);}.cls-94{fill:url(#New_Gradient_Swatch_copy_9-19);}.cls-95{fill:url(#linear-gradient-63);}.cls-96{fill:url(#New_Gradient_Swatch_copy_8-9);}.cls-97{fill:url(#linear-gradient-64);}.cls-98{fill:url(#linear-gradient-65);}.cls-99{fill:url(#linear-gradient-66);}.cls-100{fill:url(#linear-gradient-67);}.cls-101{fill:url(#linear-gradient-68);}.cls-102{fill:url(#linear-gradient-69);}.cls-103{fill:url(#linear-gradient-70);}.cls-104{fill:url(#linear-gradient-71);}.cls-105{fill:url(#linear-gradient-72);}.cls-106{fill:url(#New_Gradient_Swatch_copy_9-20);}.cls-107{fill:url(#New_Gradient_Swatch_copy_9-21);}.cls-108{fill:url(#linear-gradient-73);}.cls-109{fill:url(#linear-gradient-74);}.cls-110{fill:url(#New_Gradient_Swatch_copy_9-22);}.cls-111{fill:url(#linear-gradient-75);}.cls-112{fill:url(#linear-gradient-76);}.cls-113{fill:url(#linear-gradient-77);}.cls-114{fill:url(#linear-gradient-78);}.cls-115{fill:url(#linear-gradient-79);}.cls-116{fill:url(#linear-gradient-80);}.cls-117{fill:url(#linear-gradient-81);}.cls-118{fill:url(#linear-gradient-82);}.cls-119{fill:url(#linear-gradient-83);}.cls-120{fill:url(#linear-gradient-84);}.cls-121{fill:url(#linear-gradient-85);}.cls-122{fill:url(#linear-gradient-86);}.cls-123{fill:url(#linear-gradient-87);}.cls-124{fill:url(#linear-gradient-88);}.cls-125{fill:url(#linear-gradient-89);}.cls-126{fill:url(#linear-gradient-90);}.cls-127{fill:url(#linear-gradient-91);}.cls-128{fill:url(#linear-gradient-92);}.cls-129{fill:url(#linear-gradient-93);}.cls-130{fill:url(#linear-gradient-94);}.cls-131{fill:url(#linear-gradient-95);}.cls-132{fill:url(#linear-gradient-96);}.cls-133{fill:url(#linear-gradient-97);}.cls-134{fill:url(#linear-gradient-99);}.cls-135{fill:url(#linear-gradient-100);}.cls-136{fill:url(#linear-gradient-101);}.cls-137{fill:url(#linear-gradient-102);}.cls-138{fill:url(#linear-gradient-103);}.cls-139{fill:url(#linear-gradient-104);}.cls-140{fill:url(#linear-gradient-105);}.cls-141{fill:url(#linear-gradient-106);}.cls-142{fill:url(#linear-gradient-108);}.cls-143{fill:url(#linear-gradient-109);}.cls-144{fill:url(#linear-gradient-110);}.cls-145{fill:url(#linear-gradient-111);}.cls-146{fill:url(#linear-gradient-112);}.cls-147{fill:url(#linear-gradient-113);}.cls-148{fill:url(#linear-gradient-115);}.cls-149{fill:url(#linear-gradient-116);}.cls-150{fill:url(#linear-gradient-117);}.cls-151{fill:#2672ab;}.cls-152{fill:#d1ebff;}.cls-153{fill:#f0f8ff;}.cls-154{fill:url(#linear-gradient-118);}.cls-155{fill:#a8cff0;}.cls-156{fill:#72b5e8;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 353.69,
    y1: 75.94,
    x2: 435.42,
    y2: 231.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 352.98,
    y1: 76.52,
    x2: 434.55,
    y2: 232.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 352.27,
    y1: 77.09,
    x2: 433.68,
    y2: 232.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 351.55,
    y1: 77.67,
    x2: 432.82,
    y2: 232.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 350.84,
    y1: 78.23,
    x2: 431.96,
    y2: 232.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 350.12,
    y1: 78.8,
    x2: 431.11,
    y2: 233.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 349.4,
    y1: 79.35,
    x2: 430.27,
    y2: 233.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 348.69,
    y1: 79.9,
    x2: 429.43,
    y2: 233.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 347.97,
    y1: 80.45,
    x2: 428.6,
    y2: 234.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 347.24,
    y1: 80.98,
    x2: 427.78,
    y2: 234.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 346.52,
    y1: 81.51,
    x2: 426.97,
    y2: 234.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 345.79,
    y1: 82.02,
    x2: 426.17,
    y2: 235.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26",
    x1: 447.57,
    y1: 283.25,
    x2: 319.18,
    y2: 32.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6e41d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4c9be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 245.29,
    y1: 36.67,
    x2: 249.7,
    y2: 36.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 241.08,
    y1: 53.12,
    x2: 248.34,
    y2: 53.12,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9",
    x1: 239.85,
    y1: 39.26,
    x2: 247.95,
    y2: 39.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ae25b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d744bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 239.43,
    y1: 46.68,
    x2: 243.56,
    y2: 46.68,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 226.51,
    y1: 44.65,
    x2: 233.21,
    y2: 44.65,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 245.71,
    y1: 49.96,
    x2: 248.57,
    y2: 49.96,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-2",
    x1: 243.2,
    y1: 44.27,
    x2: 246.61,
    y2: 44.27,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 251.86,
    y1: 39.73,
    x2: 253.71,
    y2: 39.73,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 234.1,
    y1: 40.1,
    x2: 241.04,
    y2: 40.1,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 250.11,
    y1: 44.92,
    x2: 257.45,
    y2: 44.92,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8",
    x1: 228.6,
    y1: 41.83,
    x2: 237.31,
    y2: 41.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ffb892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fee1a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-3",
    x1: 230.69,
    y1: 28.99,
    x2: 237.51,
    y2: 28.99,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 239.67,
    y1: 33.16,
    x2: 243.14,
    y2: 33.16,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-4",
    x1: 235.36,
    y1: 48.78,
    x2: 238.96,
    y2: 48.78,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 255.53,
    y1: 57.55,
    x2: 264.84,
    y2: 57.55,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 221.06,
    y1: 40.59,
    x2: 224.35,
    y2: 40.59,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-2",
    x1: 214.33,
    y1: 22.15,
    x2: 228.96,
    y2: 22.15,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 257.69,
    y1: 52.61,
    x2: 261.13,
    y2: 52.61,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 259.6,
    y1: 51.1,
    x2: 269.27,
    y2: 51.1,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-5",
    x1: 248.76,
    y1: 48.42,
    x2: 255.57,
    y2: 48.42,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 255.86,
    y1: 43.71,
    x2: 263.58,
    y2: 43.71,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 221.06,
    y1: 36.67,
    x2: 226.45,
    y2: 36.67,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 250.72,
    y1: 52.84,
    x2: 253.41,
    y2: 52.84,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-6",
    x1: 221.06,
    y1: 33.79,
    x2: 231.95,
    y2: 33.79,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 250.35,
    y1: 62.36,
    x2: 256.19,
    y2: 62.36,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-3",
    x1: 221.06,
    y1: 30.97,
    x2: 237.69,
    y2: 30.97,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 245.29,
    y1: 102.95,
    x2: 249.7,
    y2: 102.95,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 241.08,
    y1: 119.4,
    x2: 248.34,
    y2: 119.4,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-4",
    x1: 239.85,
    y1: 105.54,
    x2: 247.95,
    y2: 105.54,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 239.43,
    y1: 112.95,
    x2: 243.56,
    y2: 112.95,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 226.51,
    y1: 110.93,
    x2: 233.21,
    y2: 110.93,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 245.71,
    y1: 116.24,
    x2: 248.57,
    y2: 116.24,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-7",
    x1: 243.2,
    y1: 110.55,
    x2: 246.61,
    y2: 110.55,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 251.86,
    y1: 106,
    x2: 253.71,
    y2: 106,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 234.1,
    y1: 106.37,
    x2: 241.04,
    y2: 106.37,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 250.11,
    y1: 111.19,
    x2: 257.45,
    y2: 111.19,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-5",
    x1: 228.6,
    y1: 108.1,
    x2: 237.31,
    y2: 108.1,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 230.69,
    y1: 95.26,
    x2: 237.51,
    y2: 95.26,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 239.67,
    y1: 99.44,
    x2: 243.14,
    y2: 99.44,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 235.36,
    y1: 115.06,
    x2: 238.96,
    y2: 115.06,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 255.53,
    y1: 123.82,
    x2: 264.84,
    y2: 123.82,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 221.06,
    y1: 106.87,
    x2: 224.35,
    y2: 106.87,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-6",
    x1: 214.33,
    y1: 88.43,
    x2: 228.96,
    y2: 88.43,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 257.69,
    y1: 118.88,
    x2: 261.13,
    y2: 118.88,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 259.6,
    y1: 117.37,
    x2: 269.27,
    y2: 117.37,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 248.76,
    y1: 114.7,
    x2: 255.57,
    y2: 114.7,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-8",
    x1: 255.86,
    y1: 109.98,
    x2: 263.58,
    y2: 109.98,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-9",
    x1: 221.06,
    y1: 102.95,
    x2: 226.45,
    y2: 102.95,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-10",
    x1: 250.72,
    y1: 119.11,
    x2: 253.41,
    y2: 119.11,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 221.06,
    y1: 100.07,
    x2: 231.95,
    y2: 100.07,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-11",
    x1: 221.06,
    y1: 97.25,
    x2: 237.69,
    y2: 97.25,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 241.08,
    y1: 70.92,
    x2: 248.34,
    y2: 70.92,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 239.85,
    y1: 57.06,
    x2: 247.95,
    y2: 57.06,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 239.43,
    y1: 64.48,
    x2: 243.56,
    y2: 64.48,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-12",
    x1: 226.51,
    y1: 62.45,
    x2: 233.21,
    y2: 62.45,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 245.71,
    y1: 67.76,
    x2: 248.57,
    y2: 67.76,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-13",
    x1: 243.2,
    y1: 62.07,
    x2: 246.61,
    y2: 62.07,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 234.1,
    y1: 57.89,
    x2: 241.04,
    y2: 57.89,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 228.6,
    y1: 59.62,
    x2: 237.31,
    y2: 59.62,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-14",
    x1: 235.36,
    y1: 66.58,
    x2: 238.96,
    y2: 66.58,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 255.53,
    y1: 75.34,
    x2: 264.84,
    y2: 75.34,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 221.06,
    y1: 58.39,
    x2: 224.35,
    y2: 58.39,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 257.69,
    y1: 70.4,
    x2: 261.13,
    y2: 70.4,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 248.76,
    y1: 66.22,
    x2: 255.57,
    y2: 66.22,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-15",
    x1: 221.06,
    y1: 54.47,
    x2: 226.45,
    y2: 54.47,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 250.72,
    y1: 70.63,
    x2: 253.41,
    y2: 70.63,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 221.06,
    y1: 51.59,
    x2: 231.95,
    y2: 51.59,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 238.26,
    y1: 72.51,
    x2: 241.67,
    y2: 72.51,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-7",
    x1: 229.17,
    y1: 68.33,
    x2: 236.11,
    y2: 68.33,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 252.75,
    y1: 80.84,
    x2: 256.19,
    y2: 80.84,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-16",
    x1: 243.83,
    y1: 76.66,
    x2: 250.63,
    y2: 76.66,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-8",
    x1: 216.13,
    y1: 62.03,
    x2: 227.01,
    y2: 62.03,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-17",
    x1: 221.06,
    y1: 48.77,
    x2: 237.69,
    y2: 48.77,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 241.08,
    y1: 92.97,
    x2: 248.34,
    y2: 92.97,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 239.85,
    y1: 79.11,
    x2: 247.95,
    y2: 79.11,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-18",
    x1: 239.43,
    y1: 86.53,
    x2: 243.56,
    y2: 86.53,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-19",
    x1: 226.51,
    y1: 84.5,
    x2: 233.21,
    y2: 84.5,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 245.71,
    y1: 89.81,
    x2: 248.57,
    y2: 89.81,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-9",
    x1: 243.2,
    y1: 84.12,
    x2: 246.61,
    y2: 84.12,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 234.1,
    y1: 79.94,
    x2: 241.04,
    y2: 79.94,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 228.6,
    y1: 81.67,
    x2: 237.31,
    y2: 81.67,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 235.36,
    y1: 88.63,
    x2: 238.96,
    y2: 88.63,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 255.53,
    y1: 97.39,
    x2: 264.84,
    y2: 97.39,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 221.06,
    y1: 80.44,
    x2: 224.35,
    y2: 80.44,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 257.69,
    y1: 92.45,
    x2: 261.13,
    y2: 92.45,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 248.76,
    y1: 88.27,
    x2: 255.57,
    y2: 88.27,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 221.06,
    y1: 76.52,
    x2: 226.45,
    y2: 76.52,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 250.72,
    y1: 92.68,
    x2: 253.41,
    y2: 92.68,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-20",
    x1: 221.06,
    y1: 73.64,
    x2: 231.95,
    y2: 73.64,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-21",
    x1: 238.26,
    y1: 94.56,
    x2: 241.67,
    y2: 94.56,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 229.17,
    y1: 90.38,
    x2: 236.11,
    y2: 90.38,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 252.75,
    y1: 102.89,
    x2: 256.19,
    y2: 102.89,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-22",
    x1: 243.83,
    y1: 98.71,
    x2: 250.63,
    y2: 98.71,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 220.8,
    y1: 85.4,
    x2: 227.01,
    y2: 85.4,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 221.06,
    y1: 70.82,
    x2: 237.69,
    y2: 70.82,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 250.25,
    y1: 212,
    x2: 383.07,
    y2: 212,
    gradientTransform: "translate(632.15 419.95) rotate(-179.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d513a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7a56bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#468bc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#00d2c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005b8d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 250.25,
    y1: 209.31,
    x2: 383.07,
    y2: 209.31,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 250.25,
    y1: 207.9,
    x2: 383.07,
    y2: 207.9,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 250.25,
    y1: 201.55,
    x2: 383.07,
    y2: 201.55,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 250.25,
    y1: 191.16,
    x2: 383.07,
    y2: 191.16,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 250.25,
    y1: 219.16,
    x2: 383.07,
    y2: 219.16,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 250.25,
    y1: 209.31,
    x2: 383.07,
    y2: 209.31,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 250.25,
    y1: 197.14,
    x2: 383.07,
    y2: 197.14,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 250.25,
    y1: 217.41,
    x2: 383.07,
    y2: 217.41,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 250.25,
    y1: 209.57,
    x2: 383.07,
    y2: 209.57,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 250.25,
    y1: 200.69,
    x2: 383.07,
    y2: 200.69,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 250.25,
    y1: 205.78,
    x2: 383.07,
    y2: 205.78,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 250.25,
    y1: 231.81,
    x2: 383.07,
    y2: 231.81,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 250.25,
    y1: 209.31,
    x2: 383.07,
    y2: 209.31,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 250.25,
    y1: 203.95,
    x2: 383.07,
    y2: 203.95,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 250.25,
    y1: 221.03,
    x2: 383.07,
    y2: 221.03,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 250.25,
    y1: 215.19,
    x2: 383.07,
    y2: 215.19,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 250.25,
    y1: 194.77,
    x2: 383.07,
    y2: 194.77,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 250.25,
    y1: 188.36,
    x2: 383.07,
    y2: 188.36,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 250.25,
    y1: 209.31,
    x2: 383.07,
    y2: 209.31,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 250.25,
    y1: 209.31,
    x2: 383.07,
    y2: 209.31,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 250.25,
    y1: 203.35,
    x2: 383.07,
    y2: 203.35,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 250.25,
    y1: 217.2,
    x2: 383.07,
    y2: 217.2,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 250.25,
    y1: 209.68,
    x2: 383.07,
    y2: 209.68,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 250.25,
    y1: 216.6,
    x2: 383.07,
    y2: 216.6,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 250.25,
    y1: 205.41,
    x2: 383.07,
    y2: 205.41,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 250.25,
    y1: 219.45,
    x2: 383.07,
    y2: 219.45,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 250.25,
    y1: 203.1,
    x2: 383.07,
    y2: 203.1,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 250.25,
    y1: 220.27,
    x2: 383.07,
    y2: 220.27,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 250.25,
    y1: 215.16,
    x2: 383.07,
    y2: 215.16,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 250.25,
    y1: 210.96,
    x2: 383.07,
    y2: 210.96,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 250.25,
    y1: 224.76,
    x2: 383.07,
    y2: 224.76,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 250.25,
    y1: 209.31,
    x2: 383.07,
    y2: 209.31,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 250.25,
    y1: 209.31,
    x2: 383.07,
    y2: 209.31,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 250.25,
    y1: 216.6,
    x2: 383.07,
    y2: 216.6,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 250.25,
    y1: 207.6,
    x2: 383.07,
    y2: 207.6,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 250.25,
    y1: 205.87,
    x2: 383.07,
    y2: 205.87,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 250.25,
    y1: 212.8,
    x2: 383.07,
    y2: 212.8,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 9486.13,
    y1: 276.03,
    x2: 9483.53,
    y2: 326.31,
    gradientTransform: "translate(-9260.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e9ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M391.09,131.17c-6.21-3.58-11.25-.71-11.25,6.42V226c0,7.13,5,15.82,11.25,19.41l48.31,29.19c6.21,3.58,25-14.21,25-21.34V185.11c0-7.13-7.53-15.43-13.75-19Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M390.26,131.63c-6.15-3.55-11.14-.71-11.14,6.35v87.66c0,7.06,5,15.66,11.14,19.22l49,29.46c6.16,3.55,23.61-12.86,23.61-19.92V185.16c0-7.06-7.25-15.3-13.41-18.86Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M389.42,132.09c-6.09-3.52-11-.7-11,6.29v86.91c0,7,4.93,15.51,11,19l49.63,29.74c6.09,3.51,22.25-11.51,22.25-18.5V185.21c0-7-7-15.18-13.07-18.7Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M388.59,132.55c-6-3.48-10.91-.7-10.91,6.22v86.17c0,6.92,4.88,15.35,10.91,18.83l50.29,30c6,3.48,20.88-10.15,20.88-17.07V185.26c0-6.91-6.69-15.06-12.72-18.54Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M387.76,133c-6-3.45-10.8-.69-10.8,6.15V224.6c0,6.84,4.83,15.18,10.8,18.62l50.95,30.28c6,3.45,19.52-8.8,19.52-15.65V185.31c0-6.84-6.42-14.93-12.38-18.38Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M386.92,133.46c-5.9-3.4-10.68-.68-10.68,6.1v84.69c0,6.77,4.78,15,10.68,18.43l51.62,30.55c5.9,3.41,18.16-7.45,18.16-14.22V185.36c0-6.77-6.14-14.81-12-18.21Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M386.09,133.92c-5.84-3.37-10.57-.67-10.57,6v84c0,6.7,4.73,14.87,10.57,18.24L438.37,273c5.84,3.38,16.8-6.1,16.8-12.8V185.41c0-6.7-5.86-14.68-11.7-18Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M385.26,134.38c-5.78-3.34-10.46-.67-10.46,6v83.21c0,6.63,4.68,14.71,10.46,18l52.94,31.1c5.77,3.34,15.44-4.76,15.44-11.38V185.46c0-6.63-5.59-14.56-11.36-17.89Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M384.42,134.84c-5.71-3.3-10.34-.66-10.34,5.89v82.48c0,6.55,4.63,14.54,10.34,17.84L438,272.42c5.72,3.3,14.09-3.41,14.09-10V185.51c0-6.55-5.31-14.44-11-17.73Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M383.59,135.29c-5.65-3.26-10.23-.65-10.23,5.84v81.73c0,6.48,4.58,14.38,10.23,17.64l54.26,31.65c5.65,3.27,12.73-2.06,12.73-8.54V185.56c0-6.48-5-14.31-10.69-17.57Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M382.75,135.75c-5.58-3.22-10.11-.64-10.11,5.77v81c0,6.41,4.53,14.22,10.11,17.45l54.93,31.92c5.59,3.23,11.37-.71,11.37-7.12V185.61c0-6.41-4.76-14.19-10.35-17.41Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M381.92,136.21c-5.52-3.19-10-.64-10,5.7v80.25c0,6.34,4.48,14.07,10,17.26l55.59,32.19c5.53,3.19,10,.64,10-5.7V185.66c0-6.34-4.47-14.06-10-17.25Z",
    transform: "translate(-165.87 -129.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M380.25,132.48c-5.62-3.25-10.18-.65-10.18,5.8v88.88c0,6.45,4.56,14.31,10.18,17.55L434,275.87c5.62,3.25,10.17.65,10.17-5.8V181.19c0-6.45-4.55-14.31-10.17-17.55Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "245.29 36.47 249.7 39.03 249.7 36.88 245.29 34.31 245.29 36.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "248.34 54.14 241.08 49.95 241.08 52.1 248.34 56.3 248.34 54.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "247.95 42.64 247.95 40.48 239.85 35.89 239.85 38.04 247.95 42.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "239.44 44.41 239.44 46.57 243.56 48.95 243.56 46.79 239.44 44.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "233.21 47.62 233.21 45.47 226.5 41.68 226.5 43.83 233.21 47.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "248.56 49.74 245.71 48.03 245.71 50.19 248.56 51.89 248.56 49.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "243.2 42.22 243.2 44.38 246.61 46.32 246.61 44.16 243.2 42.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "251.86 38.11 251.86 40.27 253.71 41.34 253.71 39.19 251.86 38.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "241.04 43.15 241.04 40.99 234.1 37.04 234.1 39.2 241.04 43.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "250.11 41.72 250.11 43.87 257.45 48.12 257.45 45.96 250.11 41.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "237.31 45.34 237.31 43.19 228.6 38.31 228.6 40.47 237.31 45.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "230.69 25.96 230.69 28.11 237.51 32.02 237.51 29.86 230.69 25.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "243.14 33.08 239.67 31.09 239.67 33.25 243.14 35.24 243.14 33.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "238.96 48.73 235.36 46.69 235.36 48.84 238.96 50.88 238.96 48.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "255.53 55.92 264.84 61.33 264.84 59.17 255.53 53.77 255.53 55.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "224.35 40.46 221.06 38.57 221.06 40.72 224.35 42.62 224.35 40.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "214.33 16.9 214.33 19.06 228.96 27.4 228.96 25.24 214.33 16.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "257.69 52.68 261.13 54.69 261.13 52.53 257.69 50.52 257.69 52.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "259.6 49.35 269.27 55 269.27 52.85 259.6 47.19 259.6 49.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "248.76 47.55 255.57 51.45 255.57 49.3 248.76 45.39 248.76 47.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "255.86 40.42 255.86 42.58 263.58 47 263.58 44.84 255.86 40.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "226.44 37.1 221.06 34.09 221.06 36.24 226.44 39.26 226.44 37.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "253.41 52.54 250.72 50.98 250.72 53.13 253.41 54.7 253.41 52.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "231.95 35.81 221.06 29.61 221.06 31.77 231.95 37.97 231.95 35.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "250.35 61.76 256.19 65.13 256.19 62.97 250.35 59.6 250.35 61.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "237.69 34.66 221.06 25.13 221.06 27.29 237.69 36.81 237.69 34.66"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "245.29 102.75 249.7 105.31 249.7 103.15 245.29 100.59 245.29 102.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "248.34 120.42 241.08 116.23 241.08 118.38 248.34 122.57 248.34 120.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "247.95 108.92 247.95 106.76 239.85 102.16 239.85 104.32 247.95 108.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "239.44 110.69 239.44 112.84 243.56 115.22 243.56 113.07 239.44 110.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "233.21 113.9 233.21 111.75 226.5 107.95 226.5 110.11 233.21 113.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "248.56 116.01 245.71 114.31 245.71 116.47 248.56 118.17 248.56 116.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "243.2 108.5 243.2 110.65 246.61 112.6 246.61 110.44 243.2 108.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "251.86 104.39 251.86 106.54 253.71 107.62 253.71 105.47 251.86 104.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "241.04 109.43 241.04 107.27 234.1 103.32 234.1 105.47 241.04 109.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "250.11 107.99 250.11 110.15 257.45 114.39 257.45 112.24 250.11 107.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "237.31 111.62 237.31 109.46 228.6 104.58 228.6 106.74 237.31 111.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "230.69 92.23 230.69 94.39 237.51 98.29 237.51 96.14 230.69 92.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "243.14 99.36 239.67 97.37 239.67 99.53 243.14 101.51 243.14 99.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "238.96 115 235.36 112.96 235.36 115.12 238.96 117.16 238.96 115"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "255.53 122.2 264.84 127.6 264.84 125.45 255.53 120.04 255.53 122.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "224.35 106.74 221.06 104.84 221.06 107 224.35 108.89 224.35 106.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "214.33 83.18 214.33 85.33 228.96 93.67 228.96 91.52 214.33 83.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "257.69 118.96 261.13 120.96 261.13 118.81 257.69 116.8 257.69 118.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "259.6 115.63 269.27 121.28 269.27 119.12 259.6 113.47 259.6 115.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "248.76 113.82 255.57 117.73 255.57 115.58 248.76 111.67 248.76 113.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "255.86 106.7 255.86 108.85 263.58 113.27 263.58 111.12 255.86 106.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "226.44 103.38 221.06 100.37 221.06 102.52 226.44 105.53 226.44 103.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "253.41 118.82 250.72 117.26 250.72 119.41 253.41 120.97 253.41 118.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "231.95 102.09 221.06 95.89 221.06 98.04 231.95 104.25 231.95 102.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "237.69 100.93 221.06 91.41 221.06 93.56 237.69 103.09 237.69 100.93"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "248.34 71.94 241.08 67.75 241.08 69.9 248.34 74.09 248.34 71.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "247.95 60.44 247.95 58.28 239.85 53.69 239.85 55.84 247.95 60.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "239.44 62.21 239.44 64.36 243.56 66.74 243.56 64.59 239.44 62.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "233.21 65.42 233.21 63.27 226.5 59.48 226.5 61.63 233.21 65.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "248.56 67.53 245.71 65.83 245.71 67.99 248.56 69.69 248.56 67.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "243.2 60.02 243.2 62.17 246.61 64.12 246.61 61.96 243.2 60.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "241.04 60.95 241.04 58.79 234.1 54.84 234.1 56.99 241.04 60.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "237.31 63.14 237.31 60.98 228.6 56.11 228.6 58.26 237.31 63.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "238.96 66.52 235.36 64.48 235.36 66.64 238.96 68.68 238.96 66.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "255.53 73.72 264.84 79.12 264.84 76.97 255.53 71.56 255.53 73.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "224.35 58.26 221.06 56.37 221.06 58.52 224.35 60.41 224.35 58.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "257.69 70.48 261.13 72.48 261.13 70.33 257.69 68.32 257.69 70.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "248.76 65.34 255.57 69.25 255.57 67.1 248.76 63.19 248.76 65.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "226.44 54.9 221.06 51.89 221.06 54.04 226.44 57.06 226.44 54.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "253.41 70.34 250.72 68.78 250.72 70.93 253.41 72.49 253.41 70.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "231.95 53.61 221.06 47.41 221.06 49.56 231.95 55.77 231.95 53.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "238.26 70.46 238.26 72.61 241.67 74.56 241.67 72.4 238.26 70.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "236.11 71.39 236.11 69.23 229.17 65.28 229.17 67.43 236.11 71.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "252.75 80.92 256.19 82.92 256.19 80.77 252.75 78.76 252.75 80.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "243.82 75.78 250.63 79.69 250.63 77.54 243.82 73.63 243.82 75.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "227.01 64.05 216.13 57.85 216.13 60 227.01 66.21 227.01 64.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "237.69 52.45 221.06 42.93 221.06 45.09 237.69 54.61 237.69 52.45"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "248.34 93.99 241.08 89.8 241.08 91.95 248.34 96.14 248.34 93.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "247.95 82.49 247.95 80.33 239.85 75.73 239.85 77.89 247.95 82.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "239.44 84.26 239.44 86.41 243.56 88.79 243.56 86.64 239.44 84.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "233.21 87.47 233.21 85.32 226.5 81.53 226.5 83.68 233.21 87.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "248.56 89.58 245.71 87.88 245.71 90.04 248.56 91.74 248.56 89.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "243.2 82.07 243.2 84.22 246.61 86.17 246.61 84.01 243.2 82.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "241.04 83 241.04 80.84 234.1 76.89 234.1 79.04 241.04 83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "237.31 85.19 237.31 83.03 228.6 78.16 228.6 80.31 237.31 85.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "238.96 88.57 235.36 86.53 235.36 88.69 238.96 90.73 238.96 88.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "255.53 95.77 264.84 101.17 264.84 99.02 255.53 93.61 255.53 95.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "224.35 80.31 221.06 78.42 221.06 80.57 224.35 82.46 224.35 80.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "257.69 92.53 261.13 94.53 261.13 92.38 257.69 90.37 257.69 92.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "248.76 87.39 255.57 91.3 255.57 89.15 248.76 85.24 248.76 87.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "226.44 76.95 221.06 73.94 221.06 76.09 226.44 79.11 226.44 76.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "253.41 92.39 250.72 90.83 250.72 92.98 253.41 94.54 253.41 92.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "231.95 75.66 221.06 69.46 221.06 71.61 231.95 77.82 231.95 75.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "238.26 92.51 238.26 94.66 241.67 96.61 241.67 94.45 238.26 92.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "236.11 93.44 236.11 91.28 229.17 87.33 229.17 89.48 236.11 93.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "252.75 102.97 256.19 104.97 256.19 102.82 252.75 100.81 252.75 102.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "243.82 97.83 250.63 101.74 250.63 99.59 243.82 95.68 243.82 97.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "227.01 86.1 220.8 82.54 220.8 84.69 227.01 88.26 227.01 86.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "237.69 74.5 221.06 64.98 221.06 67.14 237.69 76.66 237.69 74.5"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M345.62,215.42a.85.85,0,0,0,.86-.85l.07-15.61a.86.86,0,1,0-1.72,0l-.07,15.61A.86.86,0,0,0,345.62,215.42Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M342.85,214.19h0a.85.85,0,0,0,.86-.85l0-7.8a.87.87,0,0,0-.86-.86h0a.86.86,0,0,0-.86.85l0,7.8A.85.85,0,0,0,342.85,214.19Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M353.94,215.55a.88.88,0,0,0,.87-.86l0-7.71a.74.74,0,0,0-.74-.74h-.23a.75.75,0,0,0-.75.74l0,7.7A.87.87,0,0,0,353.94,215.55Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M317.84,224.65a.86.86,0,0,0,.86-.86l.05-13.39a.86.86,0,0,0-1.71,0l-.06,13.4A.86.86,0,0,0,317.84,224.65Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M317.82,229.35h0a.86.86,0,0,0,.86-.86v-2a.86.86,0,0,0-.86-.86h0a.86.86,0,0,0-.86.86v2A.87.87,0,0,0,317.82,229.35Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M317.9,209.1a.85.85,0,0,0,.86-.86l.08-17.51a.86.86,0,1,0-1.72,0l-.07,17.52A.85.85,0,0,0,317.9,209.1Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M315.08,220.3a.86.86,0,0,0,.86-.86l.09-20.23a.86.86,0,1,0-1.72,0l-.09,20.24A.87.87,0,0,0,315.08,220.3Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M320.6,226.74a.86.86,0,0,0,.86-.86l0-8.72a.86.86,0,1,0-1.72,0l0,8.71A.86.86,0,0,0,320.6,226.74Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M320.65,215.66a.87.87,0,0,0,.86-.86l.11-27.1a.86.86,0,1,0-1.71,0l-.12,27.1A.87.87,0,0,0,320.65,215.66Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M351.17,215.69a.86.86,0,0,0,.86-.86l.05-11.35a.75.75,0,0,0-.74-.75h-.23a.75.75,0,0,0-.75.74l-.05,11.36A.86.86,0,0,0,351.17,215.69Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M351.15,219.87A.85.85,0,0,0,352,219v-2a.75.75,0,0,0-.74-.75h-.23a.75.75,0,0,0-.75.74v2A.85.85,0,0,0,351.15,219.87Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M326.12,235a.85.85,0,0,0,.86-.85l.18-42.48a.86.86,0,1,0-1.72,0l-.18,42.48A.85.85,0,0,0,326.12,235Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M326.3,190a.87.87,0,0,0,.87-.85l0-4.59a.86.86,0,0,0-1.72,0l0,4.59A.86.86,0,0,0,326.3,190Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M334.45,231.58a.85.85,0,0,0,.87-.85l.17-42.65a.86.86,0,0,0-1.71,0l-.18,42.65A.85.85,0,0,0,334.45,231.58Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M331.7,225.93a.87.87,0,0,0,.87-.86l.08-20.64a.86.86,0,0,0-.85-.86.87.87,0,0,0-.87.86l-.08,20.64A.86.86,0,0,0,331.7,225.93Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M331.8,203.13a.86.86,0,0,0,.86-.85l0-9.21a.86.86,0,0,0-1.72,0l0,9.2A.86.86,0,0,0,331.8,203.13Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M329,219.32a.86.86,0,0,0,.86-.86l.12-29.92a.86.86,0,1,0-1.71,0l-.13,29.91A.87.87,0,0,0,329,219.32Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M329,220.06a.86.86,0,0,0-.86.86l0,6a.86.86,0,1,0,1.71,0l0-6A.87.87,0,0,0,329,220.06Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M328.92,228.53a.86.86,0,0,0-.86.86v1.87a.86.86,0,0,0,.85.86.87.87,0,0,0,.87-.85V229.4A.86.86,0,0,0,328.92,228.53Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M337.27,222.47a.85.85,0,0,0,.86-.85l.1-24.41a.86.86,0,0,0-.85-.86.87.87,0,0,0-.87.86l-.1,24.4A.85.85,0,0,0,337.27,222.47Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M323.38,224.84a.86.86,0,0,0,.87-.85l.12-29.26a.86.86,0,0,0-1.72,0L322.53,224A.85.85,0,0,0,323.38,224.84Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M340.06,217.2a.87.87,0,0,0,.87-.85l.05-13.84a.86.86,0,0,0-1.71,0l-.06,13.84A.86.86,0,0,0,340.06,217.2Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M348.36,223.72h0a.85.85,0,0,0,.86-.85l.07-15a.74.74,0,0,0-.75-.74h-.23a.73.73,0,0,0-.74.74l-.06,15A.85.85,0,0,0,348.36,223.72Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M348.43,206.21a.86.86,0,0,0,.87-.85l0-7.68a.74.74,0,0,0-.74-.75h-.23a.75.75,0,0,0-.75.74l0,7.68A.85.85,0,0,0,348.43,206.21Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M290.07,228.73a.87.87,0,0,0,.87-.86l.15-38a.86.86,0,1,0-1.71,0l-.16,38.05A.86.86,0,0,0,290.07,228.73Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M304,212.33a.87.87,0,0,0,.87-.86l.08-19a.86.86,0,0,0-1.72,0l-.08,19A.86.86,0,0,0,304,212.33Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M287.32,222.85a.87.87,0,0,0,.87-.85l.07-17.78a.86.86,0,1,0-1.72,0L286.47,222A.86.86,0,0,0,287.32,222.85Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M287.41,202.65a.86.86,0,0,0,.86-.86l0-5.45a.86.86,0,0,0-1.72,0l0,5.46A.86.86,0,0,0,287.41,202.65Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M292.89,217.79a.87.87,0,0,0,.87-.85v-3a.86.86,0,0,0-1.72,0v3A.86.86,0,0,0,292.89,217.79Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M292.92,212h0a.86.86,0,0,0,.86-.86l.11-25.66a.85.85,0,0,0-.86-.86h0a.85.85,0,0,0-.86.85l-.11,25.67A.86.86,0,0,0,292.92,212Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M295.69,212.6a.86.86,0,0,0,.86-.86l.08-19.56a.86.86,0,1,0-1.71,0l-.09,19.57A.87.87,0,0,0,295.69,212.6Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M284.59,212.25a.87.87,0,0,0,.87-.86l.06-16.08a.86.86,0,0,0-.85-.86.87.87,0,0,0-.87.86l-.06,16.08A.86.86,0,0,0,284.59,212.25Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M301.23,214.11a.85.85,0,0,0,.86-.85l.05-11.27a.86.86,0,1,0-1.72,0l0,11.27A.86.86,0,0,0,301.23,214.11Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M301.29,200.62h0a.86.86,0,0,0,.86-.86l.05-11.89a.85.85,0,0,0-.85-.86h0a.85.85,0,0,0-.87.85l-.05,11.9A.86.86,0,0,0,301.29,200.62Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M309.55,215.85a.86.86,0,0,0,.86-.85l0-11.4a.86.86,0,1,0-1.72,0L308.69,215A.86.86,0,0,0,309.55,215.85Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M312.31,219.65a.86.86,0,0,0,.86-.86l.08-19a.86.86,0,0,0-1.72,0l-.08,19A.86.86,0,0,0,312.31,219.65Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M306.8,209.81h0a.86.86,0,0,0,.86-.86l.06-13.89a.87.87,0,0,0-.86-.87h0a.87.87,0,0,0-.86.86l-.06,13.9A.87.87,0,0,0,306.8,209.81Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M298.48,209.63a.86.86,0,0,0,.86-.85l.06-13.62a.86.86,0,0,0-1.72,0l-.06,13.61A.86.86,0,0,0,298.48,209.63Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M279,215.48a.87.87,0,0,0,.86-.86l0-7.47a.86.86,0,1,0-1.71,0l0,7.47A.88.88,0,0,0,279,215.48Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M281.8,216.9a.85.85,0,0,0,.86-.85l0-6.85a.86.86,0,0,0-1.72,0l0,6.85A.85.85,0,0,0,281.8,216.9Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M281.84,207.84a.86.86,0,0,0,.86-.86v-2.56a.86.86,0,1,0-1.72,0V207A.87.87,0,0,0,281.84,207.84Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M180.59,326a7.43,7.43,0,1,1-5.59-8.89A7.42,7.42,0,0,1,180.59,326Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M165.88,315.49c-.12,5.78,1.32,8.31,8,9.85,4.75,1.1,8.24.09,9.47-3.8,2.41-7.59,5.17-19.14,7.54-25.81,2.62-7.38,6.65-12.43,3.48-16.47-3.44-4.37-14.56-12.1-19.57-9.66S166,310.78,165.88,315.49Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M174,314.31c-.57,3.71-.95,7.78,1.57,8.59,3.47,1.12,5.39-1.59,5.87-3.53.85-3.43,4.74-17.28,6.72-23,2.2-6.36,4.87-12.33,3.52-15.59-1.49-3.55-5.53-7.2-8.87-5.24S174.4,311.5,174,314.31Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M277,300.57a7.43,7.43,0,1,1,3-10.07A7.42,7.42,0,0,1,277,300.57Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M268.74,256.53c-4.37,3.17-12.58-6.94-15.75-11.31a9.78,9.78,0,0,1,15.83-11.48C272,238.11,273.11,253.36,268.74,256.53Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M273.34,241.14c-3.17-2.3-17.21,7-18.57,9.82s3.49,17.21,6.54,27.73c3.44,11.84,4.08,15.33,8.88,15.9,5.24.63,8.72-1.95,9.4-4.24C281.51,283.92,277.22,244,273.34,241.14Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M272.66,245.59c-2.58-2.61-5.84-.49-6.87,1.63s1.63,14.28,3.62,28.93c1.51,11.13.79,10.77,2.65,13.42,2.58,3.68,5.05.25,5.56-1.56C279,282.9,275.82,248.79,272.66,245.59Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M225.29,569.8",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M225.29,569.8",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M247.23,222.83c4.64-.15,15.16.55,18.16,7.51s-3,18.16-3,18.16,5.19,12.15,3.14,20.75-2,9.83-1.91,10.65,4.5,14.34.82,15.16c-1.75.39-5-.16-7.92,1.23s-4.35,5.09-9.43,8.49c-5.89,3.93-28.48,14.05-34.54,13.76-14.06-.68-18-18.29-21.57-28.94-3-9-5.6-21.44-5.6-21.44s-8.87-1.37-8.6-7.51,7.71-11.21,14.81-17.22,14.23-11.5,18.51-13.64C226.46,221.63,238.77,223.1,247.23,222.83Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M245.7,224.73c4.2-.14,13.73.49,16.45,6.8,1.21,2.8.8,6.36,0,9.45a25.05,25.05,0,0,0,.85,14.78,30.79,30.79,0,0,1,1.9,9c.23,7.59-2,10.64-1.9,11.38s-15.11,8.56-20.4,10.2c-13.75,4.27-26.2-.76-30-10.21-7.09-17.88-19-16.54-21.16-22-2.06-5.17-.86-7.47,5.7-12.75C218.83,224,238,225,245.7,224.73Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M221.29,173.41c-6.11,3.22-11.19,11.06-7,21.7s4.62,17,4.06,23.66c-.33,4-2.7,8.94-4.2,11.77a2.87,2.87,0,0,0,1,3.79c5.55,3.48,17.67,5.29,24.95.89a4.36,4.36,0,0,0,1.93-4.76,53.46,53.46,0,0,1-1.44-10.73C240.06,199.49,238.7,164.21,221.29,173.41Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M219.38,205.63c0,4,1.91,9.15,7.37,12.83s15.16,10.79,21.44,7.37,8.32-21.81,8.46-28.39c.16-7.37-2.06-20.68-10.39-25.45s-14.75-2.62-16.5-2.13c-4.49,1.24-8.33,4.64-10.65,7s.13,9.28,1.23,14.2S219.38,203.17,219.38,205.63Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M248,219.07c3.74-2.9,5.19-17,5.28-22.09.1-5.73-1.46-15.55-6.16-19.88-5.71-5.28-10.1-4.14-11.2-3.76-2.8,1-1.71,4-1,6.24A85.36,85.36,0,0,1,238.39,194C239.13,200.46,241,224.55,248,219.07Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M212.55,318.54c6.06.29,28.65-9.83,34.54-13.76,5.08-3.4,6.56-7.13,9.43-8.49s6.17-.84,7.92-1.23c3.68-.82-.69-14.34-.82-15.16a2,2,0,0,1,0-.26v0c0-.1,0-.22,0-.35h0a7.78,7.78,0,0,1,.09-1.11l-4,2.16a90.53,90.53,0,0,1-24.44,10.07c-11.17,2.6-18.87.6-25.61-12.33-4.77-9.15-18-8-24.16-9.54h0c.44,2,2.83,13,5.52,21.08C194.53,300.25,198.49,317.86,212.55,318.54Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M248,292.29c5.57-2.9,14-6.29,16.57-8.66-.49-2-.95-3.47-1-3.73a5.36,5.36,0,0,1,0-1.74l-4,2.16a90.53,90.53,0,0,1-24.44,10.07c-11.17,2.6-19.94.78-26.68-12.16-4.76-9.15-17-8.14-23.09-9.71.44,2,2.83,13,5.52,21.08,2.51,7.52,5.24,18.49,11.57,24.54a22,22,0,0,0,.92-7.55c-.65-13.78,3.54-20.23,3.54-20.23S214.83,309.6,248,292.29Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M179,265.61a23.47,23.47,0,0,0,10.33,3.21c3.19.13,7.47,1.34,7.81,4.33s-4.68,4.29-6.09,17.82-6.67,7.7-10.44-1.72C176.67,279.32,177.24,268.35,179,265.61Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M230.71,210.33c-1.21-9.93,3.72-27.92-3.8-32.74-2.81-1.8-4.44-1.56-8-.55-2,2.5.33,9.2,1.4,14s-1,12.15-1,14.61c0,4,1.91,9.15,7.37,12.83,3.95,2.67,10.11,7.1,15.6,8.07C239.57,225.15,231.72,218.7,230.71,210.33Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M226.81,210.9a12.81,12.81,0,0,0-5.82-10,4.21,4.21,0,0,0-4-.48h0l-3.78,2,.42.72a5.68,5.68,0,0,0-.31,1.94,12.81,12.81,0,0,0,5.82,10,5.78,5.78,0,0,0,1.88.73l.43.74,3.49-1.86C226.09,214.17,226.81,212.84,226.81,210.9Z",
    transform: "translate(-165.87 -129.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M223.11,212.87c0,3.69-2.6,5.17-5.81,3.32a12.84,12.84,0,0,1-5.82-10c0-3.69,2.61-5.17,5.82-3.32A12.83,12.83,0,0,1,223.11,212.87Z",
    transform: "translate(-165.87 -129.63)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictation);
export default __webpack_public_path__ + "static/media/dictation.4ce1f465511dcc1ff396c349ae36a189.svg";
export { ForwardRef as ReactComponent };